import { forwardRef } from "react";

import classnames from "classnames";

import type { ButtonButtonProps } from "@jti/core-components/components/Button";
import { Button } from "@jti/core-components/components/Button";

import styles from "./PayButton.module.scss";

type PayButtonProps = Omit<ButtonButtonProps, "children"> & {
  buttonLabel: string;
  disabled?: boolean;
  className?: string;
};

export const PayButton = forwardRef<HTMLDivElement, PayButtonProps>(
  ({ disabled = true, variant = "primary", buttonLabel, className, ...restProps }, ref) => (
    <div
      id="payButtonWrapper"
      data-disabled={disabled}
      ref={ref}
      className={classnames(styles.payButtonWrapper, className)}
    >
      <Button {...restProps} variant={variant} className={classnames(styles.btn, className)} disabled={disabled}>
        {buttonLabel}
      </Button>
    </div>
  )
);
